import { z } from "zod";

// TODO: import this from repo-wide libs folder later -J
export const PasswordSchema = z
  .string()
  .min(8, { message: "Password must be at least 8 characters long" })
  .max(32, { message: "Password must be no longer than 32 characters" })
  .regex(/[0-9]/, { message: "Password must contain at least one number" })
  .regex(/[A-Z]/, { message: "Password must contain at least one uppercase letter" });

export const SignUpBody = z.object({
  token: z.string(),
  firstName: z.string().min(2),
  lastName: z.string().min(2),
  email: z.string().email(),
  password: PasswordSchema,
  organizationName: z.string().min(2)
});

export type TSignUpBody = z.infer<typeof SignUpBody>;
